module.exports = __webpack_public_path__ + "img/succes_mascot.3208ee62.png";